module.exports = __webpack_public_path__ + "static/media/Vectordown.81b5b8fe.svg";